/* Campaign bar — alternates the message slot between its slides
   (sections/kp-announcement-bar.liquid, [data-kp-ann]). Only loaded while
   the bar has two. Holds still while the pointer or keyboard focus is on
   the bar or the tab is hidden, and never rotates a page the viewer has
   asked to keep still: reduced motion swaps without the slide. */
(() => {
  const root = document.querySelector('[data-kp-ann]');
  if (!root) return;
  const slides = Array.from(root.querySelectorAll('[data-kp-ann-slide]'));
  if (slides.length < 2) return;

  const bar = root.closest('.kp-announcement') || root;
  const seconds = Math.min(10, Math.max(3, Number(root.dataset.seconds) || 5));
  let index = 0;
  let timer = null;

  const show = (next) => {
    const to = (next + slides.length) % slides.length;
    if (to === index) return;
    slides[index].dataset.state = 'leaving';
    const left = slides[index];
    index = to;
    slides[index].dataset.state = 'active';
    window.setTimeout(() => {
      if (left.dataset.state === 'leaving') left.dataset.state = 'idle';
    }, 500);
  };

  const stop = () => {
    if (timer) window.clearInterval(timer);
    timer = null;
  };
  const start = () => {
    stop();
    if (document.hidden) return;
    timer = window.setInterval(() => show(index + 1), seconds * 1000);
  };

  bar.addEventListener('pointerenter', stop);
  bar.addEventListener('pointerleave', start);
  bar.addEventListener('focusin', stop);
  bar.addEventListener('focusout', start);
  document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
  start();
})();
